import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {DxTreeListComponent} from 'devextreme-angular';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {FusionAuthService} from '../../../../../../shared/services/fusion-auth';
import {ScreenService, UrlProviderService} from '../../../../../../shared/services/general';
import {OrdersService} from '../../../../../shared/services/orders.service';
import {ResultBase} from '../../../models/results';

@Component({
  selector: 'app-toxicology-unexpected-positive',
  templateUrl: './toxicology-unexpected-positive.component.html',
  styleUrls: ['./toxicology-unexpected-positive.component.scss'],
})
export class ToxicologyUnexpectedPositiveComponent implements OnInit, OnDestroy, OnChanges {
  @ViewChild('toxiUnexpectedPositiveTree', {static: true}) private tree?: DxTreeListComponent;
  @Input() public orderId: number = -1;
  public isLoading = false;
  public dataSource: ResultBase[] = [];
  public hasResults = false;
  public isPhoneOrTablet: boolean = false;
  @Output() public hasResultEvent = new EventEmitter();
  private onDestroy$: Subject<void> = new Subject<void>();

  constructor(private orderService: OrdersService, private urlProvider: UrlProviderService,
              private fusionAuthService: FusionAuthService, private screen: ScreenService) {
  }

  public ngOnInit() {
    this.isLoading = true;
    this.orderService.getOrderToxicologyInconsistentPositiveResults(this.orderId)
      .subscribe(result => {
        this.hasResults = result.length > 0;
        this.dataSource = result;
        this.hasResultEvent.emit(result.length > 0);
      });

    this.isPhoneOrTablet = this.screen.sizes['screen-x-small'] || this.screen.sizes['screen-small'] || this.screen.sizes['screen-tablet'];
    this.screen.changed.pipe(takeUntil(this.onDestroy$)).subscribe(() => {
      this.isPhoneOrTablet = this.screen.sizes['screen-x-small'] || this.screen.sizes['screen-small'] || this.screen.sizes['screen-tablet'];
    });
  }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.orderId.currentValue) {
      this.isLoading = true;
      this.orderService.getOrderToxicologyInconsistentPositiveResults(changes.orderId.currentValue)
        .subscribe(result => {
          this.hasResults = result.length > 0;
          this.dataSource = result;
          this.hasResultEvent.emit(result.length > 0);
        });
    }
  }
}
